import { Dropdown, IDropdownOption } from '@fluentui/react';
import React from 'react';
import {useGetGlobalStorefrontSettingsQuery, useGetStorefrontQuery} from "../../store/endpoints/StorefrontSettingsEndpoints";

interface IShippingChargeSelectionProps {
    value?: string;
    onChange?: (ShippingChargeType: string) => void;
    label?: string;
    disabled?: boolean;
    overrideValue?: string;
    storefrontId?: string;
    isLowestLevel?: boolean;
}

export const SHIPPING_CHARGE_TYPES = {
    '' : 'Inherited from global settings',
    'FLAT_RATE': 'Flat Rate',
    'PER_PRODUCT': 'Per Product',
}

export const TOP_LEVEL_SHIPPING_CHARGE_TYPES = {
    '' : 'None',
    'FLAT_RATE': 'Flat Rate',
    'PER_PRODUCT': 'Per Product',
}

const ShippingChargeSelection: React.FC<IShippingChargeSelectionProps> = (props) => {
    const globalStorefrontDetails = useGetGlobalStorefrontSettingsQuery();
    const storefrontDetails = useGetStorefrontQuery(props.storefrontId ?? '', {skip: !props.storefrontId || props.storefrontId === ''});
    const getGlobalLabel = (key: string, value: string) => {
        if( key === undefined || key.trim() === '') {
            if (props.overrideValue) {
                return props.overrideValue;
            }
            if(props.isLowestLevel){
                return globalStorefrontDetails.data?.defaultShippingChargeType && globalStorefrontDetails.data?.defaultShippingChargeType != '' ? `${value}` : "None";
            }
            if(storefrontDetails.data?.shippingChargeType && storefrontDetails.data?.shippingChargeType !== '') {
                return `Inherited from ${storefrontDetails.data?.name} (${storefrontDetails.data?.shippingChargeType})`;
            }

            return globalStorefrontDetails.data?.defaultShippingChargeType && globalStorefrontDetails.data?.defaultShippingChargeType !== '' ? `${value} (${globalStorefrontDetails.data?.defaultShippingChargeType})` : `${value} (None)`;        }
        return value;
    }
    
    const getValue =() => {
        if(props.value){
            return props.value;
        }
        return  ''
    }

    const options: IDropdownOption[] = Object.entries(props.isLowestLevel ? TOP_LEVEL_SHIPPING_CHARGE_TYPES : SHIPPING_CHARGE_TYPES).map(([key, value]) => {
            return {key, text: getGlobalLabel(key, value)}
        }
    );
    return (
        <Dropdown
            label={props.label}
            selectedKey={getValue()}
            disabled={props.disabled}
            onChange={(e, option) => {
                if (option && props.onChange) {
                    props.onChange(option.key as string);
                }
            }}
            options={options}
        />
    );
}

export default ShippingChargeSelection;